/*
 * @providesModule PhoneInputStyle
 * 
 */

import Sizes from 'Sizes';

import {
  Platform,
  StyleSheet,
} from 'react-native';

const SCREEN_WIDTH = Sizes.screenWidth;

export default StyleSheet.create({

  flexOne: {
    flex: 1,
  },

  container: {
    flexDirection: 'row',
    alignItems: 'center',
    ...Platform.select({
      ios: {
        justifyContent: 'flex-start',
      },
      android: {
        justifyContent: 'center',
      },
    }),
  },

  basicContainer: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },

  modalContainer: {
    width: SCREEN_WIDTH,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
  },

  buttonView: {
    width: SCREEN_WIDTH,
    padding: 8,
    borderTopWidth: 0.5,
    borderTopColor: 'lightgrey',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },

  bottomPicker: {
    width: SCREEN_WIDTH,
  },

  flagContainer: {
    height: 20,
    width: 30,
    
  },

  flagButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 20,
    width: Platform.select({ios: 50, native: 30}),
  },

  androidPicker: {
    ...Platform.select({
      web: {
        outlineStyle: "none",
        "-webkit-appearance": "none",
        "-moz-appearance": "none",
        opacity: 0,
      },
      native: {
        height: '300%',
      }
    }),
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },

  androidPickerFromField: {
    flex: 1,
  },

  flag: {
    height: 20,
    width: 30,
    position: Platform.select({
      ios: 'relative',
      android: 'absolute',
    }),
    borderRadius: 2,
    borderWidth: 0.5,
    borderColor: '#cecece',
    backgroundColor: '#cecece',
  },

  flagArrowIcon: {
    width: 25,
    height: 25,
    ...Platform.select({android: {marginLeft: 20}, ios: {}}),
  },

  text: {
    height: 20,
    padding: 0,
    justifyContent: 'center',
  },

  fillView: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
});
